import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Strategy, { StrategyDefaultSettings } from "./Strategy";
import snappy from "../utils/snappy";
import sleep from "../utils/sleep";
import { echoError } from "../utils/logger";
import { POST_REPORT_RESOURCE, MULTI_POST_REPORT_RESOURCE, MULTI_MAX_SIZE, MULTI_MAX_SIZE_ERROR } from "../constants/conf";
export var MultiPostStrategyDefaultSettings = Object.assign({}, StrategyDefaultSettings, {
  wait: 'immediately'
});

var MultiPostStrategy = /*#__PURE__*/function (_Strategy) {
  _inherits(MultiPostStrategy, _Strategy);

  var _super = _createSuper(MultiPostStrategy);

  function MultiPostStrategy() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MultiPostStrategyDefaultSettings;
    var initialData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, MultiPostStrategy);

    _this = _super.call(this, options, initialData);
    _this.trackingTasks = [];
    _this.trackingReportors = [];
    return _this;
  }
  /**
   * 上报
   * @param partialTrackingData 部分跟踪数据
   */


  _createClass(MultiPostStrategy, [{
    key: "report",
    value: function () {
      var _report = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(partialTrackingData) {
        var immediately,
            task,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                immediately = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;

                if (Array.isArray(partialTrackingData)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", this.report([partialTrackingData], immediately));

              case 3:
                this.addTask.apply(this, _toConsumableArray(partialTrackingData));

                if (!immediately) {
                  _context.next = 7;
                  break;
                }

                task = this.trackingTasks.pop();
                return _context.abrupt("return", this.tryReport([task]));

              case 7:
                return _context.abrupt("return", this.runReport());

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function report(_x) {
        return _report.apply(this, arguments);
      }

      return report;
    }()
    /** 立即上报所有 */

  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var tasks;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!true) {
                  _context2.next = 8;
                  break;
                }

                tasks = this.freeTrackingTask();

                if (!(tasks.length > 0)) {
                  _context2.next = 5;
                  break;
                }

                this.tryReport(tasks);
                return _context2.abrupt("continue", 0);

              case 5:
                return _context2.abrupt("break", 8);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function post() {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "use",
    value: function use(type, interceptor) {
      _get(_getPrototypeOf(MultiPostStrategy.prototype), "use", this).call(this, type, interceptor);
    }
    /**
     * 添加上报任务
     * @param trackingDatas 跟踪数据
     */

  }, {
    key: "addTask",
    value: function addTask() {
      var _this2 = this;

      for (var _len = arguments.length, trackingDatas = new Array(_len), _key = 0; _key < _len; _key++) {
        trackingDatas[_key] = arguments[_key];
      }

      trackingDatas.forEach(function (data) {
        var source = _this2.processTrackingData(data);

        var encoded = _this2.encodeTrackingData(source);

        if (_this2.validTrackingData(encoded)) {
          var _payload = {
            encoded: encoded,
            source: source
          };

          _this2.trackingTasks.push(_payload);
        }
      });
    }
    /**
     * 执行上报队列
     */

  }, {
    key: "runReport",
    value: function () {
      var _runReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$options, maxRequest, wait, tasks, promise;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$options = this.options, maxRequest = _this$options.maxRequest, wait = _this$options.wait;

                if (!(this.trackingReportors.length >= maxRequest)) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return Promise.all(this.trackingReportors);

              case 4:
                if (!MultiPostStrategy.supported) {
                  _context3.next = 13;
                  break;
                }

                if (!(wait === 'nextTick')) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 8;
                return Promise.resolve();

              case 8:
                _context3.next = 13;
                break;

              case 10:
                if (!(typeof wait === 'number')) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 13;
                return sleep(wait);

              case 13:
                tasks = this.freeTrackingTask();

                if (!(tasks.length > 0)) {
                  _context3.next = 18;
                  break;
                }

                promise = this.tryReport(tasks);
                _context3.next = 18;
                return this.pushReport(promise);

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function runReport() {
        return _runReport.apply(this, arguments);
      }

      return runReport;
    }()
    /**
     * 释放任务
     * @description
     * 因为有上报大小的限制, 所以这里通过总大小来释放可执行的任务数量.
     * 长度大小需要按最终JSON串的大小, 因此需要注意标点符号的大小;
     * 标点符号每次递增3个长度, 以1为初始值每次额外加上3个长度
     * ```ts
     * // [""] => 4
     * // ["",""] => 7
     * // ["","",""] => 10
     * ```
     */

  }, {
    key: "freeTrackingTask",
    value: function freeTrackingTask() {
      var total = 1;

      for (var i = 0; i < this.trackingTasks.length; i++) {
        var encoded = this.trackingTasks[i].encoded;
        total += encoded.length + 3;

        if (total > MULTI_MAX_SIZE) {
          return this.trackingTasks.splice(0, i);
        }
      }

      return this.trackingTasks.splice(0);
    }
    /**
     * 尝试上报
     * @param encodedTrackingDatas 编码后的跟踪数据
     */

  }, {
    key: "tryReport",
    value: function () {
      var _tryReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(trackingTasks) {
        var time,
            _this$options2,
            useHttps,
            domain,
            baseUrl,
            _this$options3,
            useRetry,
            retryTimes,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                time = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 0;
                _context4.prev = 1;
                _this$options2 = this.options, useHttps = _this$options2.useHttps, domain = _this$options2.domain;
                baseUrl = "http".concat(useHttps !== false ? 's' : '', "://").concat(domain);
                _context4.next = 6;
                return this.delegateRequest(baseUrl, trackingTasks);

              case 6:
                _context4.next = 16;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);
                _this$options3 = this.options, useRetry = _this$options3.useRetry, retryTimes = _this$options3.retryTimes;

                if (!(useRetry === true && retryTimes > time)) {
                  _context4.next = 15;
                  break;
                }

                _context4.next = 14;
                return this.tryReport(trackingTasks, time + 1);

              case 14:
                return _context4.abrupt("return", _context4.sent);

              case 15:
                return _context4.abrupt("return", Promise.reject(_context4.t0));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 8]]);
      }));

      function tryReport(_x2) {
        return _tryReport.apply(this, arguments);
      }

      return tryReport;
    }()
    /**
     * 添加上报过程
     * @param promise 上报的回调
     */

  }, {
    key: "pushReport",
    value: function pushReport(promise) {
      var _this3 = this;

      var remove = function remove() {
        var index = _this3.trackingReportors.indexOf(promise);

        _this3.trackingReportors.splice(index, 1);
      };

      var reject = function reject(error) {
        remove();
        return Promise.reject(error);
      };

      var reportor = promise.then(remove)["catch"](reject);
      this.trackingReportors.push(reportor);
      return reportor;
    }
    /**
     * 委派请求
     * @param baseUrl 原始URL
     * @param payload 编译后的跟踪数据
     * @description
     * 主要为了适配不兼容批量上传的情况, 进行筛选处理, 让批量上报也支持单个上报
     */

  }, {
    key: "delegateRequest",
    value: function delegateRequest(baseUrl, payload) {
      if (!Array.isArray(payload)) {
        var _url = this.interceptUrl("".concat(baseUrl, "/").concat(POST_REPORT_RESOURCE), payload);

        if (this.options.skipReport) return Promise.resolve();
        return this.send(_url, payload.encoded);
      }

      if (payload.length === 1) {
        return this.delegateRequest(baseUrl, payload[0]);
      }

      return this.mergeRequest(baseUrl, payload);
    }
    /**
     * 合并请求
     * @param baseUrl 原始URL
     * @param payload 编译后的跟踪数据
     */

  }, {
    key: "mergeRequest",
    value: function mergeRequest(baseUrl, payload) {
      var data = payload.map(function (_ref) {
        var encoded = _ref.encoded;
        return encoded;
      });
      var body = this.compressTrackingDatas(data);
      var url = this.interceptUrl("".concat(baseUrl, "/").concat(MULTI_POST_REPORT_RESOURCE, "?cmp=1&enc=b64"), payload);
      if (this.options.skipReport) return Promise.resolve();
      return this.send(url, body);
    }
    /**
     * 拦截 URL
     * @param url 请求地址
     * @param payload 编译后的跟踪数据
     * @param options 配置
     */

  }, {
    key: "interceptUrl",
    value: function interceptUrl(url, payload) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.options;

      if (typeof this.urlInterceptor === 'function') {
        return this.urlInterceptor(url, payload, options);
      }

      return url;
    }
    /**
     * 压缩跟踪数据
     * @param encodedTrackingDatas 已编码的跟踪数据
     * @description
     * 只有批量上报才需要压缩, 如果不支持 buffer 或 btoa 则此方法不会被执行
     */

  }, {
    key: "compressTrackingDatas",
    value: function compressTrackingDatas(encodedTrackingDatas) {
      var json = JSON.stringify(encodedTrackingDatas);
      var buff = snappy(json);
      var text = String.fromCharCode.apply(null, new Uint8Array(buff));
      return btoa(text);
    }
    /**
     * 验证跟踪数据是否合法
     * @param encodedTrackingData 已编码的跟踪数据
     */

  }, {
    key: "validTrackingData",
    value: function validTrackingData(encodedTrackingData) {
      if (encodedTrackingData.length > MULTI_MAX_SIZE) {
        echoError(MULTI_MAX_SIZE_ERROR);
        return false;
      }

      return true;
    }
  }, {
    key: "destory",
    value: function destory() {
      _get(_getPrototypeOf(MultiPostStrategy.prototype), "destory", this).call(this);

      this.trackingTasks.splice(0);
      this.trackingReportors.splice(0);
      this.trackingTasks = undefined;
      this.trackingReportors = undefined;
    }
  }]);

  return MultiPostStrategy;
}(Strategy);

_defineProperty(MultiPostStrategy, "supported", typeof btoa === 'function' && typeof Uint16Array !== 'undefined');

export { MultiPostStrategy as default };